import React, { useLayoutEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import "./styles.css";
import { PopupsContext } from '../../../../utils';
export var PopoverContext = React.createContext({});
export var createPortalRoot = function (rootId, className) {
    var rootElement = document.createElement('div');
    rootElement.id = rootId;
    if (className)
        rootElement.className = className;
    return rootElement;
};
export var Modal = function (_a) {
    var contentRect = _a.contentRect, children = _a.children;
    var _b = useState({
        x: 0,
        y: 0,
    }), coords = _b[0], setCoords = _b[1];
    var applicationRootElementId = React.useContext(PopoverContext).applicationRootElementId;
    var _c = React.useContext(PopupsContext), applicationElementID = _c.applicationElementID, rootElement = _c.rootElement;
    var rootElementID = applicationRootElementId || applicationElementID || 'root';
    var MAX_HEIGHT = 56;
    var getXCoords = function () {
        var _a;
        // Because property 'ref' does not exist on type ReactElement by default.
        // @ts-ignore
        var modalObj = children.ref.current;
        var bodyCoords = (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (contentRect && bodyCoords && modalObj) {
            var modalCoords = modalObj.getBoundingClientRect();
            /**
              Если по ширине вылазим за правый край, смещаемся влево на ширину формы
            */
            return bodyCoords.width - (contentRect === null || contentRect === void 0 ? void 0 : contentRect.x) < modalCoords.width
                ? bodyCoords.width - modalCoords.width
                : contentRect === null || contentRect === void 0 ? void 0 : contentRect.x;
        }
        return 0;
    };
    var getYCoords = function () {
        if (contentRect) {
            return (contentRect === null || contentRect === void 0 ? void 0 : contentRect.y) - (MAX_HEIGHT / 2 - (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) / 2);
        }
        return 0;
    };
    useLayoutEffect(function () {
        setCoords({ x: getXCoords(), y: getYCoords() });
    }, [contentRect]);
    var mount = rootElement || document.getElementById(rootElementID);
    if (!mount) {
        throw new Error("Application root element with ID \"" + rootElementID + "\" not found");
    }
    var portalRoot = createPortalRoot('lk-ui_inline-edit_portal-root-id', 'lk-ui_inline-edit_portal-root');
    var container = mount.appendChild(portalRoot);
    var modal = (React.createElement("div", { className: 'lk-ui_inline-edit-modal' },
        React.createElement("div", { className: 'lk-ui_inline-edit-modal_positioner', style: {
                position: 'absolute',
                left: coords.x + "px",
                top: coords.y + "px",
            } }, children)));
    return ReactDOM.createPortal(modal, container);
};
